import gql from 'graphql-tag';

export const CREATE_LEAD = gql`
  mutation CreateLead($input: CreateLeadInput!) {
    createLead(input: $input) {
      lead {
        leadId
      }
    }
  }
`;

export const CREATE_ENQUIRY = gql`
  mutation CreateEnquiry($input: CreateEnquiryInput!) {
    createEnquiry(input: $input) {
      enquiry {
        enquiryId
      }
      clientMutationId
    }
  }
`;
